import api from '@/shared/api/api-client';

import type { ResetPasswordGateway } from './reset-password.gateway';

/**
 * Real implementation over the shared api client. The single place that knows
 * the endpoint (kept 1:1 with the original `ResetPassword` page's
 * `api.post('/auth/reset-password', { token, password })`). The client prefixes
 * `/v1`, and `/v1/auth/*` endpoints are CSRF-exempt; the response body is unused.
 */
export const httpResetPasswordGateway: ResetPasswordGateway = {
  resetPassword: async (input) => {
    await api.post('/auth/reset-password', input);
  },
};
